import { CheckCircleIcon, XCloseIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import type { NorfolkSouthernRequestResponse } from '@rsos/reduxDataStore/src/features/resourceRequests';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { formatDateWithLocalTimezone } from '../../../../../utils/dateUtilities';
import styles from './NorfolkSouthernStatus.module.css';

interface NorfolkSouthernStatusHeaderProps {
  request: NorfolkSouthernRequestResponse;
}

/** Title, request time, carrier phone, and the outcome, error and test banners. */
function NorfolkSouthernStatusHeader({
  request,
}: NorfolkSouthernStatusHeaderProps): JSX.Element {
  const transformed = request.request;
  const isFailed = transformed.consistState === 'failed';

  const requestedAtDisplay = formatDateWithLocalTimezone(
    request.createdAt,
    'HH:mm',
  );

  return (
    <>
      <div className={styles.header}>
        <Text color="primaryText" size="large" fontWeight="bold">
          Train Consist Request
        </Text>
        <div className={styles.headerMeta}>
          Requested at: {requestedAtDisplay}
        </div>
        <div className={styles.headerMeta}>Norfolk Southern</div>
        {transformed.phoneNumber && (
          <div
            className={styles.headerPhone}
            data-name="norfolk-southern-carrier-phone"
          >
            Emergency line:{' '}
            {formatInternationalPhoneNumberHuman(transformed.phoneNumber)}
          </div>
        )}
      </div>

      {isFailed ? (
        <div
          className={`${styles.banner} ${styles.failedBanner}`}
          data-name="norfolk-southern-status-banner"
        >
          <XCloseIcon color="background" height={16} width={16} />
          <Text color="background" size="normal">
            Train consist request failed
          </Text>
        </div>
      ) : (
        <div
          className={`${styles.banner} ${styles.successBanner}`}
          data-name="norfolk-southern-status-banner"
        >
          <CheckCircleIcon color="background" height={16} width={16} />
          <Text color="background" size="normal">
            Train consist request successful
          </Text>
        </div>
      )}
      {isFailed && transformed.error && (
        <div
          className={styles.errorText}
          data-name="norfolk-southern-status-error"
        >
          {transformed.error}
        </div>
      )}
    </>
  );
}

export default NorfolkSouthernStatusHeader;
